/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Thumbor from '@common_image';
import Link from 'next/link';
import React from 'react';
import { basePath, modules } from '@config';
import cx from 'classnames';
import ProductLabelAmasty from '@common/ProductLabelAmasty';
import Typography from '@common/Typography';

const ImageDetail = (props) => {
    const {
        handleClick, small_image, spesificProduct, urlKey, name, storeConfig = {},
        classContainer = '', className = '', isGrid, preload = false, amasty_product_labels, isOos,
        amasty_sell_product_labels = [],
    } = props;

    let defaultWidth = modules?.catalog?.productListing?.imageSize?.width;
    let defaultHeight = modules?.catalog?.productListing?.imageSize?.height;

    if (typeof defaultWidth === 'string') defaultWidth = parseInt(defaultWidth, 10);
    if (typeof defaultHeight === 'string') defaultHeight = parseInt(defaultHeight, 10);

    let classImage = '!w-full !h-full';

    const imageUrl = spesificProduct.id
        ? spesificProduct.image.url
        : small_image?.url || `${basePath}/assets/img/placeholder.png`;

    const imageAlt = small_image?.label || name;

    if (!isGrid) {
        classImage = '!w-[120px] !h-[120px] tablet:!w-[320px] tablet:!h-[320px] desktop:!w-[320px] desktop:!h-[320px]';
    }

    return (
        <>
            <Link
                href={{
                    pathname: '/[...slug]',
                    query: {
                        slug: urlKey,
                    },
                }}
                onClick={handleClick}
                className={cx(`overflow-hidden flex justify-center wrapper-image-plp transition-opacity !duration-500
                    group-hover/itemPLP:opacity-70 after:content-[''] after:absolute after:w-full after:h-full after:bg-[rgb(0,0,0,.03)]`)}
                style={{ background: 'rgba(0, 0, 0, .03)' }}
            >
                <ProductLabelAmasty amasty_product_labels={amasty_product_labels} amasty_sell_product_labels={amasty_sell_product_labels} />
                {isOos && (
                    <div
                        className="oos-overlay absolute top-[0] left-[0] w-full h-[100%] bg-[rgba(0,0,0,.3)] z-[1] flex items-center"
                    >
                        <Typography
                            variant="p-2a"
                            className={cx(
                                'uppercase !text-neutral-white text-center tablet:!text-[25px] tablet:leading-[31px]',
                                'font-bold block bg-[rgba(0,0,0,.19)] tablet:py-2 w-full h-fit',
                                '!text-[15px] leading-[18px] py-[6px]',
                            )}
                        >
                            Sold-Out
                        </Typography>
                    </div>
                )}
                <Thumbor
                    src={imageUrl}
                    className={cx(classImage, 'overflow-hidden', className)}
                    classContainer={cx(classImage, classContainer)}
                    styleContainer={{ padding: 0 }}
                    styleImage={{ position: 'relative' }}
                    width={defaultWidth}
                    height={defaultHeight}
                    quality={80}
                    alt={imageAlt}
                    storeConfig={storeConfig}
                    preload={preload}
                    retina
                />
            </Link>
        </>
    );
};

export default ImageDetail;
